module.exports = __webpack_public_path__ + "img/Qrespi-Logo-m.2a11eabd.svg";